const {h, render, Component} = require('preact')

class ErrorPage extends Component {
  constructor(props) {
    super(props);
  }

  getSupportBaseURL(){
    let configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom && configFromDom.SUPPORTBASEURL)
      return configFromDom.SUPPORTBASEURL;
  }

  render() {
    return (
      <div class="content" data-bhw="web2018_error_page">
        <div class="page-error error text-center">
          <h1>{I18n.translate('js.modules.support.oops')}</h1>
          <div class="error-content">
            <p>{I18n.translate('js.modules.support.error_happend')}</p>
            <p>
              <a target="_top" class="error_reload" href={this.getSupportBaseURL()}>{I18n.translate('js.modules.support.reload')}</a>&nbsp;
              {I18n.translate('js.modules.support.reload_text')}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = ErrorPage
